import { render, staticRenderFns } from "./ChatSummary.vue?vue&type=template&id=350c400f&"
import script from "./ChatSummary.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ChatSummary.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports